import $ from "jquery";
import whatInput from "what-input";

window.$ = window.jQuery = $;
window.whatInput = whatInput;

export default $;